import { Modal } from "antd";
import DeleteModel from "../../../../assets/icons/DeleteModel.svg"
import "./DeleteConfirmModel.css"
import { DeleteConfirmModelProps } from "../../../../utilities/types/common";
import { useModalContainer } from "../../../../utilities/Models/modelUtils";

const DeleteConfirmModel = ({ visible, onCancel, title, content, onConfirm, cancelText, okText }: DeleteConfirmModelProps) => {

    const modalContainer = useModalContainer();

    return (
        <div>
            <Modal
                className="deleteModal"
                closable={false}
                centered
                open={visible}
                okText={okText}
                cancelText={cancelText}
                onOk={onConfirm}
                onCancel={onCancel}
                mask={false}
                maskClosable={false}
                width={350}
                getContainer={() => modalContainer || document.body}
            >
                <div className="deleteModalIcon">
                    <img src={DeleteModel} alt="DeleteModel" className="mx-auto text-center d-block" />
                </div>
                {title && <h6 className="m-3 text-center title">{title}</h6>}
                {content && <p className="mb-4 text-center content">{content}</p>}
            </Modal>
        </div>
    )
}
export default DeleteConfirmModel